// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'XS' | 'S' | 'M' | 'L' | 'XL' | number, // NOTE: イレギュラーサイズはそのまま数値を渡すようにする
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
/** @deprecated src/components/iconに定義されている新しいアイコンに置き換えます。
 *
 * 特段の理由がない場合、新規実装でこちらは使用しないでください。 */
const SvgAccount2 = ({ size = 'S', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'XS'
        ? '8px'
        : size === 'S'
        ? '16px'
        : size === 'M'
        ? '24px'
        : size === 'L'
        ? '32px'
        : size === 'XL'
        ? '40px'
        : size
    }
    height={
      size === 'XS'
        ? '8px'
        : size === 'S'
        ? '16px'
        : size === 'M'
        ? '24px'
        : size === 'L'
        ? '32px'
        : size === 'XL'
        ? '40px'
        : size
    }
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <circle cx={16} cy={16} r={16} fill="#fff" />
    <mask id="account2_svg__a" fill="#fff">
      <path
        fillRule="evenodd"
        d="M2.281 24.656a1.75 1.75 0 0 1-.27-1.144c.766-6.825 6.557-12.13 13.586-12.13 7.17 0 13.05 5.52 13.626 12.54.033.403-.076.804-.305 1.137-2.884 4.189-7.714 6.935-13.184 6.935-5.644 0-10.605-2.923-13.453-7.338"
        clipRule="evenodd"
      />
    </mask>
    <path
      fill={props.color ?? 'currentColor'}
      fillRule="evenodd"
      d="M2.281 24.656a1.75 1.75 0 0 1-.27-1.144c.766-6.825 6.557-12.13 13.586-12.13 7.17 0 13.05 5.52 13.626 12.54.033.403-.076.804-.305 1.137-2.884 4.189-7.714 6.935-13.184 6.935-5.644 0-10.605-2.923-13.453-7.338"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="m29.223 23.922-1.993.164zm-.305 1.137-1.647-1.135zm-26.637-.403-1.68 1.085zm1.717-.92c.655-5.825 5.6-10.353 11.599-10.353v-4C7.538 9.383.902 15.463.023 23.289zm11.599-10.353c6.12 0 11.141 4.71 11.633 10.703l3.986-.327c-.66-8.05-7.4-14.376-15.619-14.376zm11.674 10.541c-2.527 3.67-6.752 6.07-11.537 6.07v4c6.156 0 11.59-3.093 14.831-7.8zm-11.537 6.07c-4.936 0-9.277-2.554-11.772-6.422L.601 25.741c3.2 4.96 8.781 8.253 15.133 8.253zm11.496-5.908a.25.25 0 0 1 .04-.162l3.295 2.27a3.75 3.75 0 0 0 .651-2.435zM.023 23.289c-.097.865.112 1.73.578 2.451l3.361-2.168c.028.043.043.1.036.163z"
      mask="url(#account2_svg__a)"
    />
    <circle
      cx={15.5}
      cy={11.5}
      r={6.5}
      fill={props.color ?? 'currentColor'}
      stroke="#fff"
      strokeWidth={2}
    />
  </svg>
)
export default SvgAccount2
